<template>
  <page-view :title="false">
    <a-button type="primary" @click="toggleCollapsed" style="margin-bottom: 16px">
      <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
    </a-button>
    <a-row>
      <a-col :span="list_span">
        <a-list
          class="demo-loadmore-list"
          :loading="loading"
          itemLayout="horizontal"
          :dataSource="queue.data"
          :bordered="true"
          size="small">
          <div v-if="showLoadingMore" slot="loadMore" :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
            <a-spin v-if="loadingMore" />
            <a-button v-else @click="getQueue">Load more ...</a-button>
          </div>
          <a-list-item slot="renderItem" slot-scope="item">
            <a-button @click="setQueueItem(item)" block>{{ item.batch }}</a-button>
          </a-list-item>
        </a-list>
      </a-col>
      <a-col :span="12">
        <div style="overflow:scroll">
          <chart-viewer></chart-viewer>
        </div>

      </a-col>
      <a-col :span="metadata_span">
        <metadata-form></metadata-form>
      </a-col>
    </a-row>
  </page-view>
</template>
<script>
import { PageView } from '@/layouts'
import HeadInfo from '@/components/tools/HeadInfo'
import ChartViewer from '@/components/ChartViewer'
import MetadataForm from '@/components/MetadataForm'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Queue',
  components: {
    PageView,
    HeadInfo,
    ChartViewer,
    MetadataForm
  },
  data () {
    this.getQueue()
    return {
      // TODO refactor this shiz
      avatar: '',
      user: {},

      projects: [],
      loading: false,
      radarLoading: true,
      activities: [],
      teams: [],
      showLoadingMore: true,
      collapsed: true,
      list_span: 0,
      metadata_span: 12

      // data
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'queue',
      'loadingMore'
    ])
  },
  created () {
    this.user = this.userInfo
  },
  mounted () {
  },
  methods: {
    ...mapActions([
      'getQueue', 'setQueueItem'
    ]),
    onLoadMore () {

    },
    process (b) {
      console.log(b)
    },
    toggleCollapsed () {
      this.collapsed = !this.collapsed
      if (this.collapsed) {
        this.metadata_span = 12
        this.list_span = 0
      } else {
        this.metadata_span = 9
        this.list_span = 3
      }
    }
  }
}
</script>

<style scoped>
.ant-list-item{
  padding:0px;
}

 </style>
